export const ERROR_400 = 'Requisição inválida. Verifique os dados e tente novamente.';
export const ERROR_401 = 'Não autorizado. Por favor, faça login.';
export const ERROR_403 = 'Acesso negado. Você não tem permissão para acessar este recurso.';
export const ERROR_404 = 'Recurso não encontrado.';
export const ERROR_500 = 'Erro interno do servidor. Tente novamente mais tarde.';
export const ERROR_USER_ALREADY_EXISTS = 'Usuário já existe. Por favor, escolha outro.';
export const ERROR_INVALID_CREDENTIALS = 'Credenciais inválidas. Verifique seu email e senha.';
export const SUCCESS_REGISTER = 'Registro realizado com sucesso! Você já pode fazer login.';
export const SUCCESS_LOGIN = 'Login realizado com sucesso! Bem-vindo de volta.';
export const LOGOUT_MESSAGE = 'Você saiu com sucesso.';
export const CLOSE_MESSAGE = 'Fechar';
export const GENERIC_ERROR = 'Ocorreu um erro. Tente novamente.';
export const NETWORK_ERROR = 'Erro de rede. Verifique sua conexão com a internet.';
export const VALIDATION_ERROR = 'Erro de validação. Verifique os dados fornecidos.';
export const TIMEOUT_ERROR = 'Tempo de requisição esgotado. Tente novamente.';
export const UNKNOWN_ERROR = 'Erro desconhecido. Tente novamente mais tarde.';
export const LOADING_MESSAGE = 'Carregando... Por favor, aguarde.';
export const SUBMIT_BUTTON = 'Enviar';
export const CANCEL_BUTTON = 'Cancelar';
export const CLOSE_BUTTON = 'Fechar';
export const RETRY_BUTTON = 'Tentar novamente';
export const LOGIN_PROMPT = 'Por favor, faça login para continuar.';
export const REGISTER_PROMPT = 'Crie uma conta para começar.';